import { Center } from "./WelcomeScreen.Center";
import { MenuHint, ToolbarHint, HelpHint, AIHint } from "./WelcomeScreen.Hints";

import "./WelcomeScreen.scss";

const WelcomeScreen = (props: { children?: React.ReactNode }) => {
  return (
    <>
      {props.children || (
        <>
          <Center />
          <MenuHint />
          <ToolbarHint />
          <HelpHint />
          <AIHint />
        </>
      )}
    </>
  );
};

WelcomeScreen.displayName = "WelcomeScreen";

WelcomeScreen.Center = Center;
WelcomeScreen.Hints = { MenuHint, ToolbarHint, HelpHint, AIHint };

export default WelcomeScreen;
